import axios from 'axios'
import { API_BASE } from '../config'
import { endSession } from './session'

// Keeps the logged-in visitor marked as online while the site is open: once a minute, while the tab is on screen, it
// tells the backend "still here". The backend shows a user as online for a little longer than that after it last
// heard from them, and as "last seen" after that.

const PING_MS = 60 * 1000;

let lastPing = 0;

function ping() {
    let token = localStorage.getItem('token');
    if (token === null || document.hidden) {
        return;
    }
    lastPing = Date.now();
    axios.post(`${API_BASE}/auth/ping`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((response) => {
        // the login has run out: stop the site behaving as though it were still good
        if (response.data && response.data.loggedIn === false && localStorage.getItem('token') === token) {
            endSession(true);
        }
    }).catch(() => { /* the backend can't be reached just now: try again next time */ });
}

// Start saying "still here". Returns a function that stops it.
export function startPresence() {
    ping();
    let timer = setInterval(ping, PING_MS);
    // coming back to the tab says so straight away, unless it only just did
    let onVisible = () => {
        if (!document.hidden && Date.now() - lastPing > PING_MS / 2) {
            ping();
        }
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
        clearInterval(timer);
        document.removeEventListener('visibilitychange', onVisible);
    };
}

// How long ago a time was, for "Last seen ...": just now, 5 minutes ago, 3 hours ago, yesterday, 4 days ago, then the date
export function timeAgo(value, now = Date.now()) {
    let then = new Date(value).getTime();
    let minutes = Math.floor((now - then) / 60000);
    let some = (n, word) => `${n} ${word}${n === 1 ? '' : 's'} ago`;
    if (minutes < 1) {
        return 'just now';
    }
    if (minutes < 60) {
        return some(minutes, 'minute');
    }
    let hours = Math.floor(minutes / 60);
    if (hours < 24) {
        return some(hours, 'hour');
    }
    let days = Math.floor(hours / 24);
    if (days === 1) {
        return 'yesterday';
    }
    if (days < 30) {
        return some(days, 'day');
    }
    return 'on ' + new Date(then).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}
